import { Heart } from '@phosphor-icons/react';

export default function VenmoDonate({ compact = false }) {
  const venmoUrl = 'https://venmo.com/PayShoreline?txn=pay&note=lets%20keep%20our%20site%20free';

  if (compact) {
    return (
      <a
        href={venmoUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-4 py-2 rounded-sm text-sm font-sans font-semibold transition-all duration-200 bg-[#008CFF]/10 text-[#008CFF] hover:bg-[#008CFF]/20 border border-[#008CFF]/20"
        data-testid="venmo-donate-btn"
      >
        <Heart size={16} weight="fill" className="text-[#008CFF]" />
        Support Us
      </a>
    );
  }

  return (
    <div className="rounded-sm border border-border p-4 space-y-3" data-testid="venmo-donate-card">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-[#008CFF]/10 flex items-center justify-center">
          <Heart size={16} weight="fill" className="text-[#008CFF]" />
        </div>
        <div>
          <p className="text-sm font-sans font-semibold text-foreground">Support GolfScroll</p>
          <p className="text-[11px] font-sans text-muted-foreground">lets keep our site free</p>
        </div>
      </div>
      <a
        href={venmoUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 w-full py-2.5 rounded-sm text-sm font-sans font-bold transition-all duration-200 bg-[#008CFF] text-white hover:bg-[#006FCC]"
        data-testid="venmo-donate-link"
      >
        <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current" aria-hidden="true">
          <path d="M19.5 2c.8 1.3 1.2 2.7 1.2 4.4 0 5.5-4.7 12.6-8.5 17.6H5.2L2.5 2.8l6-.6 1.5 12c1.4-2.3 3.1-5.9 3.1-8.3 0-1.6-.3-2.7-.7-3.6L19.5 2z" />
        </svg>
        Donate via Venmo
      </a>
    </div>
  );
}
